import { store } from './store.js';
// ========================================
// PASO 6: SOLUCIÓN FINAL (Opción Múltiple)
// ========================================
import { wizardState, getString, isSubtraction } from './wizardState.js';
import { safeSetHTML } from './security.js';

function getSpanishPlural(word) {
    if (!word || typeof word !== 'string') return 'cosas';
    const clean = word.trim();
    if (!clean) return 'cosas';

    const lower = clean.toLowerCase();
    if (lower.endsWith('s')) return clean;
    if (lower.endsWith('z')) return clean.slice(0, -1) + 'ces';
    if (/[bcdfghjklmnpqrtvwxyz]$/i.test(lower) || lower.endsWith('ch')) return clean + 'es';
    return clean + 's';
}

export function initializeSolutionStep() {
    if (!store.state || !store.state.problems) return;

    const problem = store.state.problems[store.state.currentProblem];

    // 1. OBTENER NÚMERO CALCULADO (SOLO DEL ESTADO - SIN RECALCULO FORZADO)
    // Esto asegura que si el usuario no ha calculated, no se muestre el número.
    let finalNumber = wizardState.data.calculation;

    // UI References
    const numberDisplay = document.getElementById('selectedFinalNumber');
    const goToCalcBtn = document.getElementById('goToCalcBtn');

    // 2. MOSTRAR NÚMERO EN EL UI
    if (numberDisplay) {
        // Validamos que sea un número real (0 es válido)
        if (finalNumber !== null && finalNumber !== undefined && !isNaN(finalNumber)) {
            // Tenemos un número calculado previamente
            numberDisplay.textContent = finalNumber;
            numberDisplay.dataset.value = finalNumber;
            numberDisplay.classList.remove('empty');
            numberDisplay.style.color = '#0f172a'; // Ensure contrast

            // Ocultar botón de volver al cálculo ya que tenemos dato
            if (goToCalcBtn) goToCalcBtn.classList.add('hidden');
        } else {
            // No hay cálculo todavía
            numberDisplay.textContent = '?';
            numberDisplay.dataset.value = '';
            numberDisplay.style.color = '#94a3b8';

            // Mostrar botón para ir a calcular
            if (goToCalcBtn) {
                goToCalcBtn.classList.remove('hidden');
                goToCalcBtn.style.display = 'inline-block'; // Force display
            }
        }
    }

    // 3. GENERAR OPCIONES (OBJETOS)
    // Obtener el objeto correcto (plural)
    const objectNames = window.getAllObjectNames ? window.getAllObjectNames(problem) : ['objetos'];
    // Usamos el de la pregunta detectado en paso 4 si existe, sino el primero del problema
    let rawElement = wizardState.data.questionElement || objectNames[0] || 'cosas';

    // Ensure plural correctly with Spanish morphology
    const correctElement = getSpanishPlural(rawElement);

    // Contexto de verbos (sumado/restado)
    const verbSpan = document.getElementById('operationVerb');
    if (verbSpan) {
        verbSpan.textContent = isSubtraction(problem) ? 'restado' : 'sumado';
    }
    const elementSpan = document.getElementById('operatedElement');
    if (elementSpan) {
        elementSpan.textContent = correctElement;
    }

    /* --- GENERAR 4 OPCIONES (Updated to 4) --- */
    // Alternativas genéricas si no hay sistema de contexto
    const distractions = ['cosas', 'elementos', 'fichas', 'puntos', 'lápices', 'libros', 'manzanas', 'peras', 'coches', 'animales'].filter(x => x !== correctElement);
    // Shuffle distractions
    distractions.sort(() => Math.random() - 0.5);

    const alt1 = distractions[0] || 'cosas';
    const alt2 = distractions[1] || 'objetos';
    const alt3 = distractions[2] || 'elementos';

    // Opciones: Solo texto del objeto
    const optCorrect = { text: correctElement, correct: true };
    const optDist1 = { text: alt1, correct: false };
    const optDist2 = { text: alt2, correct: false };
    const optDist3 = { text: alt3, correct: false }; // Added 4th option

    // Mezclar
    const options = [optCorrect, optDist1, optDist2, optDist3];
    options.sort(() => Math.random() - 0.5);

    // 4. RENDERIZAR OPCIONES
    const container = document.getElementById('elementOptions'); // ID correcto según index.html
    if (!container) return;

    safeSetHTML(container, '');
    // Use grid layout for 4 items (2x2) usually looks good, or just list
    container.style.display = 'grid';
    container.style.gridTemplateColumns = '1fr 1fr';
    container.style.gap = '10px';

    options.forEach(opt => {
        const btn = document.createElement('button');
        btn.className = 'btn btn-option-card';
        btn.style.width = '100%';
        btn.style.margin = '0'; // Let grid handle gap
        btn.style.padding = '1rem';
        btn.style.fontSize = '1.2rem';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.textContent = opt.text; // Solo el nombre del objeto

        btn.onclick = () => selectFinalOption(btn, opt);

        container.appendChild(btn);
    });

    // Resetear botón de envío
    const submitBtn = document.getElementById('submitFinalAnswerBtn');
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.remove('hidden');
    }
    
    // Esconder el botón de siguiente problema si estaba visible
    const nextBtn = document.getElementById('nextProblemBtnStep6');
    if (nextBtn) {
        nextBtn.classList.add('hidden');
    }

    // Novedad: Recargar botones de voz
    if (window.addSafeAudioButtons) {
        setTimeout(window.addSafeAudioButtons, 100);
    }

    Logger.info('🏁 Paso final inicializado.');
}

let selectedOptionData = null;

function selectFinalOption(btnElement, optionData) {
    // Quitar selección previa
    const container = document.getElementById('elementOptions');
    if (container) {
        const buttons = container.querySelectorAll('.btn-option-card');
        buttons.forEach(b => b.classList.remove('selected'));
    }

    // Marcar nuevo
    btnElement.classList.add('selected');
    selectedOptionData = optionData;

    // Habilitar envío si tenemos número y opción
    const submitBtn2 = document.getElementById('submitFinalAnswerBtn');
    const numDisplay = document.getElementById('selectedFinalNumber');

    // Solo permitir enviar si hay un número válido seleccionado (no vacío y no '?')
    const hasNumber = numDisplay && numDisplay.dataset.value !== '';

    if (submitBtn2 && hasNumber) {
        submitBtn2.disabled = false;
    } else if (submitBtn2) {
        // Si no hay número, mantenemos deshabilitado
        submitBtn2.disabled = true;
    }
}

export function submitFinalAnswer() {
    if (!selectedOptionData) return;

    // ✅ VERIFICACIÓN: El usuario debe haber calculado el resultado en el Paso 5
    const hasCalculation = wizardState.data.calculation !== null &&
        wizardState.data.calculation !== undefined &&
        !isNaN(wizardState.data.calculation);

    if (!hasCalculation) {
        // El detective avisa que hay que calcular primero
        const detectiveMsg = '¡Espera, detective! Antes de completar el problema, necesitas calcular el resultado usando alguno de los métodos del Paso 5: la tabla de cálculo, la tabla numérica ABN o el cálculo mental. ¡Vuelve al Paso 5 y calcula primero!';

        if (window.DetectiveMentor && typeof window.DetectiveMentor.speak === 'function') {
            window.DetectiveMentor.speak(detectiveMsg, 'warning', 6000);
        } else if (window.showWizardFeedback) {
            window.showWizardFeedback(detectiveMsg, false);
            if (window.speak) window.speak(detectiveMsg, window.currentLanguage || 'es-ES');
        } else {
            alert(detectiveMsg);
        }

        // Resaltar el botón de volver al paso 5
        const goToCalcBtn = document.getElementById('goToCalcBtn');
        if (goToCalcBtn) {
            goToCalcBtn.classList.remove('hidden');
            goToCalcBtn.style.display = 'inline-block';
            goToCalcBtn.style.animation = 'pulse 1s ease-in-out 3';
            setTimeout(() => { goToCalcBtn.style.animation = ''; }, 3000);
        }
        return;
    }

    const problem = store.state.problems[store.state.currentProblem];
    const isCorrect = selectedOptionData.correct;

    // Ensure errorCounts is defined defensively
    if (!wizardState.data.errorCounts) {
        wizardState.data.errorCounts = {};
    }

    if (isCorrect) {
        // Success
        if (typeof wizardState.data.errorCounts.step6 !== 'undefined') {
            wizardState.data.errorCounts.step6 = 0;
        }
        if (window.playSuccess) window.playSuccess();
        if (window.confetti) window.confetti();
        if (window.showWizardFeedback) window.showWizardFeedback(getString('feedbackGreat'), true, true);
        
        // Let the detective mentor propose the new problem
        if (window.DetectiveMentor && typeof window.DetectiveMentor.speak === 'function') {
            window.DetectiveMentor.speak('¡Excelente trabajo detective! Caso cerrado. ¿Estás listo para un nuevo reto?', 'success');
        }

        // Ocultar botón de enviar
        const submitBtn = document.getElementById('submitFinalAnswerBtn');
        if (submitBtn) submitBtn.classList.add('hidden');

        // Automatically finish problem after a delay
        setTimeout(() => {
            if (typeof window.finishCurrentProblem === 'function') {
                window.finishCurrentProblem(true);
            } else {
                if (window.markProblemComplete) window.markProblemComplete(true);
            }
        }, 3000);

    } else {
        // Error
        if (typeof wizardState.data.errorCounts.step6 === 'undefined') {
            wizardState.data.errorCounts.step6 = 0;
        }
        wizardState.data.errorCounts.step6 += 1;
        
        if (window.playError) window.playError();

        let msg = window.getFeedbackForAttempt ? 
            window.getFeedbackForAttempt('step6', wizardState.data.errorCounts.step6, problem) : 
            '¡Vaya! Esa no es la solución exacta. ¡Inténtalo de nuevo!';

        if (window.DetectiveMentor && typeof window.DetectiveMentor.speak === 'function') {
            window.DetectiveMentor.speak(msg, 'warning', 6000);
        }

        // Show error feedback
        const feedbackEl = document.querySelector('.wizard-step-feedback');
        if (feedbackEl) {
            feedbackEl.textContent = msg;
            feedbackEl.style.display = 'block';
            feedbackEl.style.color = 'var(--color-error, #dc3545)';

            setTimeout(() => {
                feedbackEl.style.display = 'none';
            }, 3000);
        }
    }

    // 2. Registro en Motor de Recomendación
    if (window.RecommendationEngine) {
        RecommendationEngine.recordAttempt(
            problem.type || 'unknown',
            isCorrect,
            isCorrect ? null : 'final_selection_error'
        );
    }
}

// Exponer funciones globalmente
window.submitFinalAnswer = submitFinalAnswer;
window.initializeSolutionStep = initializeSolutionStep;
